import React from 'react';
import NavbarInv from '../../components/navbarInv';
import OpcionesInicioInv from '../../components2/opcionesInicioInv';
import ModalInicio from '../../components2/modalInicio';
import Navbar from '../../components/navbar';

function Beneficiario() {
    return (
        <>
            <ModalInicio />
            <OpcionesInicioInv />
        </>
    )
}

export default Beneficiario;